import { Component, OnInit, ViewContainerRef } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import {
  isLargeScreen,
  formatDateTimeStamp,
} from '../../../../../../global.variable';
import { ModalDialogueService } from '../../../../../shared/components/modal-dialogue/modal-dialogue.service';
import { LoadingSpinnerService } from '../../../../../shared/services/loading-spinner.service';
import { ToasterService } from '../../../../../shared/services/toaster.service';
import { UsersService } from '../../../users/users.service';
import { ClientsService } from '../../clients.service';

@Component({
  selector: 'gtapp-site-key-list',
  standalone: false,
  templateUrl: './site-key-list.html',
  styleUrl: './site-key-list.scss',
})
export class SiteKeyList implements OnInit {
  largeView: Boolean = isLargeScreen;
  // site key search params
  siteKeySearchLookup: any = {};
  siteListData: any = [];
  clientListData: any = [];
  clientDropDownList: any = [];
  initialDataList: any = {};

  siteKeyListData: any = [];

  searchedSiteKeyData: any = {};
  previousSiteKey: number = 0;
  pageSizeSiteKey: number = 2;
  pageNumSiteKey: number = 1;
  totalPagesSiteKey: number = 0;
  otherParamsSiteKey: any = { apiFiltering: true };
  totalCountSiteKeys: number = 0;

  searchedSiteKeyTableDetail: any = this.largeView
    ? [
        {
          header: 'Key',
          name: 'key',
          tableColumnStyle: {
            'white-space': 'pre-line',
          },

          suffixNestedValue: (row: any) => {
            return row?.master_key ? ` \n Master Key` : null;
          },
          suffixStyle: { 'font-size': '0.7rem' },
        },
        {
          header: 'Description',
          name: 'description',
        },
        {
          header: 'Site',
          tableColumnStyle: {
            'white-space': 'pre-line',
          },
          nestedValue: (row: any) => {
            return row?.master_key && row?.global_client
              ? row?.company_name
              : row?.site_name;
          },
          suffixNestedValue: (row: any) => {
            return row?.master_key && row?.global_client
              ? ` \n Available for all ${row?.company_name} sites`
              : ` \n ${row?.site_address} \n[${row?.company_name}]`;
          },
          suffixStyle: { 'font-size': '0.8rem' },
        },
        {
          header: 'Added',
          nestedValue: (row: any) => {
            const addedDate =
              this.searchedSiteKeyData?.additionalInfo?.[row?.additional_key];
            if (!addedDate) return null;
            return formatDateTimeStamp(addedDate, 'd MMM y HH:mm', 'en_US');
          },
        },
      ]
    : [
        {
          header: 'Key',
          name: 'key',
          tableColumnStyle: {
            'white-space': 'pre-line',
          },

          suffixNestedValue: (row: any) => {
            let list = ['\n'];
            if (row?.description) list.push(row?.description);
            if (row?.master_key) list.push(`Master Key`);
            return list?.join('\n');
          },
          suffixStyle: { 'font-size': '0.7rem' },
        },

        {
          header: 'Site',

          tableColumnStyle: {
            'white-space': 'pre-line',
          },
          nestedValue: (row: any) => {
            return row?.master_key && row?.global_client
              ? row?.company_name
              : row?.site_name;
          },
          suffixNestedValue: (row: any) => {
            return row?.master_key && row?.global_client
              ? ` \n Available for all ${row?.company_name} sites`
              : ` \n ${row?.site_address} \n[${row?.company_name}]`;
          },
          suffixStyle: { 'font-size': '0.8rem' },
        },
      ];

  // grouped site list params
  // site key search params

  previousGroupedSiteList: number = 0;
  pageSizeGroupedSiteList: number = 5;
  pageNumGroupedSiteList: number = 1;
  totalPagesGroupedSiteList: number = 0;
  otherParamsGroupedSiteList: any = { apiFiltering: true };
  sortKeyGroupedSiteList: any = '';
  searchParamsGroupedSiteList: any;
  totalCountGroupedSiteLists: number = 0;
  groupedSiteListData: any = [];

  // grouped client list params
  // site key search params

  previousGroupedClientList: number = 0;
  pageSizeGroupedClientList: number = 10;
  pageNumGroupedClientList: number = 1;
  totalPagesGroupedClientList: number = 0;
  otherParamsGroupedClientList: any = { apiFiltering: true };
  sortKeyGroupedClientList: any = '';
  searchParamsGroupedClientList: any;
  totalCountGroupedClientLists: number = 0;
  groupedClientListData: any = [];

  selectedGroupedSite: any = {};
  selectedGroupedClient: any = [];

  constructor(
    private clientService: ClientsService,
    private spinnerService: LoadingSpinnerService,
    private router: Router,
    private route: ActivatedRoute,
    private toasterService: ToasterService,
    private dialogService: ModalDialogueService,
    private userService: UsersService,
    private viewContainerRef: ViewContainerRef,
  ) {
    if (this.route.snapshot.fragment) {
      const urlSearchParams =
        JSON.parse(atob(this.route.snapshot.fragment)) || {};

      if (
        Object.values(urlSearchParams)?.length &&
        urlSearchParams?.siteKeySearchLookup &&
        Object.values(urlSearchParams?.siteKeySearchLookup)?.length
      ) {
        this.siteKeySearchLookup = urlSearchParams?.siteKeySearchLookup;
      }
    }

    if (this.siteKeySearchLookup?.searched) {
      this.onSiteKeySearch();
    } else {
      this.getGroupedClientKeyList();
    }

    this.searchClients('');
    this.onSiteSearch('');
  }
  ngOnInit(): void {}

  onSearchGroupedSiteKeyTable(event: any) {
    if (this.selectedGroupedClient?.id) {
      this.searchParamsGroupedSiteList = event?.searchParams || {};
      this.previousGroupedSiteList = 0;
      this.pageNumGroupedSiteList = 1;
      this.getGroupedSiteKeyList();
    } else {
      this.searchParamsGroupedClientList = event?.searchParams || {};
      this.previousGroupedClientList = 0;
      this.pageNumGroupedClientList = 1;
      this.getGroupedClientKeyList();
    }
  }
  onSortGroupedSiteKeyTable(event: any) {
    if (this.selectedGroupedClient?.id) {
      this.sortKeyGroupedSiteList = event?.sortList || [];

      this.getGroupedSiteKeyList();
    } else {
      this.sortKeyGroupedClientList = event?.sortList || [];

      this.getGroupedClientKeyList();
    }
  }

  onChangeGroupedSiteKeyTablePagination(data: any) {
    if (this.selectedGroupedClient?.id) {
      this.previousGroupedSiteList = data?.paginationData?.previousRows;
      this.pageNumGroupedSiteList = data?.paginationData?.pageNum;
      this.pageSizeGroupedSiteList = data?.paginationData?.rows;

      this.getGroupedSiteKeyList();

      this.otherParamsGroupedSiteList.paginationData = {
        ...data?.paginationData,
      };
    } else {
      this.previousGroupedClientList = data?.paginationData?.previousRows;
      this.pageNumGroupedClientList = data?.paginationData?.pageNum;
      this.pageSizeGroupedClientList = data?.paginationData?.rows;

      this.getGroupedClientKeyList();

      this.otherParamsGroupedClientList.paginationData = {
        ...data?.paginationData,
      };
    }
  }
  onGroupedRowClick(event: any) {
    if (this.selectedGroupedClient?.id) {
      this.selectedGroupedSite = {};
      setTimeout(() => {
        this.selectedGroupedSite = {
          ...{ id: event?.company_uuid, company_name: event?.name, ...event },
          company: this.selectedGroupedClient,
        };
      });
    } else {
      this.selectedGroupedClient = {
        id: event?.company_uuid,
        company_name: event?.name,
        ...event,
      };
      this.previousGroupedSiteList = 0;
      this.pageNumGroupedSiteList = 1;
      this.getGroupedSiteKeyList();
    }
  }
  getGroupedClientKeyList() {
    let params: any = { grouped: 1 };

    if (this.pageSizeGroupedClientList)
      params['rows'] = this.pageSizeGroupedClientList;

    if (this.previousGroupedClientList)
      params['previous'] = this.previousGroupedClientList;

    if (this.sortKeyGroupedClientList)
      params['sort_key'] = this.sortKeyGroupedClientList;

    if (this.searchParamsGroupedClientList)
      params.search_filters = JSON.stringify(
        this.searchParamsGroupedClientList,
      );

    this.spinnerService.show();
    this.clientService.listSiteKeys(params).then((res: any) => {
      if (res['status'] == 'success') {
        this.totalCountGroupedClientLists = res['total_size'];

        this.totalPagesGroupedClientList = Math.ceil(
          this.totalCountGroupedClientLists / this.pageSizeGroupedClientList,
        );

        this.spinnerService.hide();
        this.otherParamsGroupedClientList.paginationData = {
          totalRows: this.totalCountGroupedClientLists,
          previousRows: this.previousGroupedClientList,
          rows: this.pageSizeGroupedClientList,
          pageNum: this.pageNumGroupedClientList,
          totalPages: this.totalPagesGroupedClientList,
        };
        this.groupedClientListData = res?.data || [];
        this.otherParamsGroupedClientList = {
          ...this.otherParamsGroupedClientList,
        };
      } else {
        this.toasterService.setMessage({
          successMessage: '',
          errorMessage: res['message'],
        });
        this.spinnerService.hide();
      }
    });
  }

  onChangeGroupedSiteKeyListPagination(data: any) {}
  getGroupedSiteKeyList() {
    let params: any = { grouped: 1 };

    if (this.pageSizeGroupedSiteList)
      params['rows'] = this.pageSizeGroupedSiteList;

    if (this.previousGroupedSiteList)
      params['previous'] = this.previousGroupedSiteList;
    if (this.sortKeyGroupedSiteList)
      params['sort_key'] = this.sortKeyGroupedSiteList;

    if (this.searchParamsGroupedSiteList)
      params.search_filters = JSON.stringify(this.searchParamsGroupedSiteList);

    if (this.selectedGroupedClient?.id)
      params['client_id'] = this.selectedGroupedClient?.id;

    // this.spinnerService.show();
    this.clientService.listSiteKeys(params).then((res: any) => {
      if (res['status'] == 'success') {
        this.totalCountGroupedSiteLists = res['total_size'];

        this.totalPagesGroupedSiteList = Math.ceil(
          this.totalCountGroupedSiteLists / this.pageSizeGroupedSiteList,
        );

        // this.spinnerService.hide();
        this.otherParamsGroupedSiteList.paginationData = {
          totalRows: this.totalCountGroupedSiteLists,
          previousRows: this.previousGroupedSiteList,
          rows: this.pageSizeGroupedSiteList,
          pageNum: this.pageNumGroupedSiteList,
          totalPages: this.totalPagesGroupedSiteList,
          fixedRows: true,
        };
        this.groupedSiteListData = res?.data || [];
        this.otherParamsGroupedSiteList = {
          ...this.otherParamsGroupedSiteList,
        };
      } else {
        this.toasterService.setMessage({
          successMessage: '',
          errorMessage: res['message'],
        });
        // this.spinnerService.hide();
      }
    });
  }

  onChangeSiteKeyTablePagination(data: any) {
    this.previousSiteKey = data?.paginationData?.previousRows;
    this.pageNumSiteKey = data?.paginationData?.pageNum;
    this.pageSizeSiteKey = data?.paginationData?.rows;

    this.listAllSiteKeys();

    this.otherParamsSiteKey = {
      paginationData: { ...data?.paginationData },
    };
  }

  listAllSiteKeys() {
    let params: any = {};

    if (this.siteKeySearchLookup?.searchStr)
      params['search_str'] = this.siteKeySearchLookup?.searchStr;

    if (this.siteKeySearchLookup?.site_data?.id) {
      params['site_id'] = this.siteKeySearchLookup?.site_data?.id;
      if (this.siteKeySearchLookup?.site_data?.company?.id)
        params['client_id'] = this.siteKeySearchLookup?.site_data?.company?.id;
    }

    if (this.siteKeySearchLookup?.client_data?.id)
      params['client_id'] = this.siteKeySearchLookup?.client_data?.id;

    if (this.pageSizeSiteKey) params['rows'] = this.pageSizeSiteKey;

    if (this.previousSiteKey) params['previous'] = this.previousSiteKey;

    this.spinnerService.show();
    this.clientService.listSiteKeys(params).then((res: any) => {
      if (res['status'] == 'success') {
        this.totalCountSiteKeys = res['total_size'];

        this.totalPagesSiteKey = Math.ceil(
          this.totalCountSiteKeys / this.pageSizeSiteKey,
        );

        this.spinnerService.hide();
        this.otherParamsSiteKey = {
          paginationData: {
            totalRows: this.totalCountSiteKeys,
            previousRows: this.previousSiteKey,
            rows: this.pageSizeSiteKey,
            pageNum: this.pageNumSiteKey,
            totalPages: this.totalPagesSiteKey,
          },
        };
        this.searchedSiteKeyData = {
          data: res?.data,
          additionalInfo: res?.additional_info,
        };
        this.router.navigate([], {
          fragment: btoa(
            JSON.stringify({
              siteKeySearchLookup: this.siteKeySearchLookup,
              selectedTab: 'Site Keys (Search)',
            }),
          ),
          queryParams: {},
          replaceUrl: true, // Replaces the current URL without adding a new history entry
        });
      } else {
        this.toasterService.setMessage({
          successMessage: '',
          errorMessage: res['message'],
        });
        this.spinnerService.hide();
      }
    });
  }
  onSiteKeySearch(clearAll = false) {
    if (clearAll) {
      this.searchedSiteKeyData = {};
      this.previousSiteKey = 0;
      this.pageNumSiteKey = 1;
      this.siteKeySearchLookup = {};
      this.router.navigate([], {
        queryParams: {},
        replaceUrl: true, // Replaces the current URL without adding a new history entry
      });
    } else {
      this.previousSiteKey = 0;
      this.pageNumSiteKey = 1;
      this.siteKeySearchLookup.searched = true;
      this.listAllSiteKeys();
      // previousSiteKey: number = 0;
      // pageSizeSiteKey: number = 10;
      // pageNumSiteKey: number = 1;
      // totalPagesSiteKey: number = 0;
    }
  }
  shiftFocus(elementId: string) {
    setTimeout(() => {
      var element = <HTMLInputElement>document.getElementById(elementId);
      element?.focus();
    }, 200);
  }
  editField(field: string) {
    if (field == 'searchStr') {
      this.siteKeySearchLookup.searchStr = '';
      this.shiftFocus('searchSiteKeys');
    }
    if (field == 'site') {
      this.siteKeySearchLookup.site_data = {};
      this.siteKeySearchLookup.client_data = {};
      this.shiftFocus('siteId');
      this.updateInitialDataList(field);
    }
    if (field == 'client') {
      this.siteKeySearchLookup.site_data = {};
      this.siteKeySearchLookup.client_data = {};
      this.shiftFocus('clientLookupId');
      this.updateInitialDataList(field);
    }
  }
  inputFocused(field: string) {
    this.siteKeySearchLookup.client_data = {};
    this.siteKeySearchLookup.site_data = {};
    if (field === 'site') {
      this.siteKeySearchLookup.client_data = {};
      setTimeout(() => {
        this.siteKeySearchLookup.client_data = {
          disabled: true,
        };
      }, 10);
    }
    if (field === 'client') {
      this.siteKeySearchLookup.site_data = {};
      setTimeout(() => {
        this.siteKeySearchLookup.site_data = {
          disabled: true,
        };
      }, 10);
    }
    this.updateInitialDataList(field);
  }
  updateInitialDataList(field: any) {
    this.siteListData = [];
    this.clientListData = [];
    setTimeout(() => {
      if (field === 'site') {
        this.siteListData = JSON.parse(
          JSON.stringify(this.initialDataList?.[field] || []),
        );
      } else if (field === 'client') {
        this.clientListData = JSON.parse(
          JSON.stringify(this.initialDataList?.[field] || []),
        );
      }
    }, 200);
  }
  onSiteSearch(event?: any) {
    const searchString = event ? event.target.value : '';

    this.clientService
      .searchSites({
        search_str: searchString,
      })
      .subscribe((res: any) => {
        if (res['status'] == 'success') {
          this.siteListData = res?.data?.splice(0, 10);
          if (!event) {
            this.initialDataList.site = JSON.parse(
              JSON.stringify(this.siteListData),
            );
          }
        }
      });
  }
  onClientSearch(event: any) {
    if (
      event.target.value.length === 3 ||
      (event.target.value.length > 3 && this.clientDropDownList?.length)
    ) {
      this.searchClients(event.target.value);
    }
  }
  searchClients(searchStr?: any) {
    this.clientService.searchClients(searchStr).subscribe((res: any) => {
      if (res['status'] == 'success') {
        this.clientDropDownList = res?.data;
        if (!searchStr) {
          this.initialDataList.client = JSON.parse(
            JSON.stringify(this.clientDropDownList),
          );
        }
      }
    });
  }
  onSiteRedirect(event: any) {
    this.router.navigate(['/view-site', { sKey: String(event?.site_id) }]);
  }

  siteKeyListUpdated(event: any) {
    if (this.selectedGroupedClient?.id) {
      this.getGroupedSiteKeyList();
    } else {
      // this.getGroupedClientKeyList();
    }
  }
}
